import { render } from "./BluePlacemat.svg?vue&type=template&id=549ccc40"
const script = {}
script.render = render

export default script